import { Skeleton } from "../skeleton";

import styles from "./side-panel-skeleton.module.css";

const HEADER_TITLE_HEIGHT = 24;
const HEADER_TITLE_WIDTH = 160;
const CARD_ITEM_BAR_HEIGHT = 16;

const CARD_SECTIONS = [
	[
		{ labelWidth: "75%", valueWidth: "50%" },
		{ labelWidth: "55%", valueWidth: "85%" },
		{ labelWidth: "60%", valueWidth: "25%" },
	],
	[
		{ labelWidth: "80%", valueWidth: "50%" },
		{ labelWidth: "75%", valueWidth: "50%" },
		{ labelWidth: "50%", valueWidth: "35%" },
		{ labelWidth: "65%", valueWidth: "70%" },
		{ labelWidth: "45%", valueWidth: "30%" },
	],
	[
		{ labelWidth: "80%", valueWidth: "45%" },
		{ labelWidth: "75%", valueWidth: "40%" },
		{ labelWidth: "85%", valueWidth: "25%" },
	],
];

type CardItemSkeletonProps = {
	labelWidth: string;
	valueWidth: string;
};

function CardItemSkeleton({ labelWidth, valueWidth }: CardItemSkeletonProps) {
	return (
		<div className={styles.cardItem}>
			<Skeleton height={CARD_ITEM_BAR_HEIGHT} width={labelWidth} />
			<Skeleton height={CARD_ITEM_BAR_HEIGHT} width={valueWidth} />
		</div>
	);
}

export function HeaderSkeleton() {
	return <Skeleton height={HEADER_TITLE_HEIGHT} width={HEADER_TITLE_WIDTH} />;
}

export function BodySkeleton() {
	return (
		<div className={styles.card}>
			{CARD_SECTIONS.map((items, sectionIndex) => {
				return (
					<div className={styles.cardSection} key={sectionIndex}>
						{items.map((item) => {
							return (
								<CardItemSkeleton
									key={`${item.labelWidth}-${item.valueWidth}`}
									{...item}
								/>
							);
						})}
					</div>
				);
			})}
		</div>
	);
}
